import { Box, Typography } from "@mui/material";

interface SimpleDataRenderProps {
  label: string;
  value?: number | string | undefined | null;
}

const SimpleDataRender = ({ label, value }: SimpleDataRenderProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
      }}
    >
      <Typography
        variant="shirtViewText"
        sx={{
          marginBottom: "0.5rem",
          color: "#6f7d95 !important",
          fontWeight: "600 !important",
        }}
      >
        {label}
      </Typography>

      <Typography variant="shirtViewText">
        {value !== null && value !== undefined ? value : "-"}
      </Typography>
    </Box>
  );
};

export default SimpleDataRender;
